import { keysOf, boot } from '@dazn/bootstrap-lib';

import { blacklist } from './garbageCollectorConfig';

const removeApplicationGarbage = (
    objectToCleanup: Record<string, unknown>,
    keysToRemove: Readonly<string[]>,
) =>
    keysToRemove
        .filter(garbageItem => {
            const descriptor = Object.getOwnPropertyDescriptor(
                objectToCleanup,
                garbageItem,
            );
            if (!descriptor) {
                return false;
            }
            const { writable, configurable } = descriptor;
            return writable && configurable;
        })
        .forEach(garbageItem => delete objectToCleanup[garbageItem]);

const itemsToRemove = (
    currentWindowKeys: Readonly<string[]>,
    blacklist: Readonly<string[]>,
) =>
    blacklist.filter(blackListItem =>
        currentWindowKeys.includes(blackListItem),
    );

const collectGarbage = (
    blacklist: Readonly<string[]>,
    whitelist: Readonly<string[]>,
    env: boot.config.Environment | undefined,
    _window: Record<string, unknown> = window as any,
) => {
    const currentWindowKeys = keysOf(_window);

    removeApplicationGarbage(
        _window,
        itemsToRemove(currentWindowKeys, blacklist),
    );
};

const garbageCollector = (
    env: boot.config.Environment | undefined,
    window?: Record<string, unknown>,
) => collectGarbage(blacklist, [], env, window);

export { collectGarbage, garbageCollector };
